import { DirectorReturnType } from '@commenda/api';
import { IncorporationRequestDataType } from '@commenda/types';
import { BoardPositionEnum } from '@commenda/types/src/random';
import { WorkRequestResponseType } from '@commenda/types/src/work-request/types';
import { BaseDirectorType } from './DirectorFormType';

export const getDirectorName = (director: BaseDirectorType) => {
  if (!director) return '';

  const { directorFirstName, directorMiddleName, directorLastName } = director;

  return directorMiddleName
    ? `${directorFirstName} ${directorMiddleName} ${directorLastName}`
    : directorLastName
      ? `${directorFirstName} ${directorLastName}`
      : directorFirstName;
};

export const groupTitlesByDirectorIds = (input: Record<string, string>) => {
  const result = {};

  Object.entries(input).forEach(([title, id]) => {
    if (!result[id]) result[id] = [];

    result[id].push(title);
  });

  return result;
};

export const findDirectorByRole = (
  data: WorkRequestResponseType & { requestData: IncorporationRequestDataType },
  role: BoardPositionEnum
) => {
  return data?.directors?.find((director) =>
    director.corporationHasDirector?.some(
      (dir) =>
        dir.corporationId === data?.corporationId &&
        dir.directorId === director.id &&
        dir.additionalDirectorInformation?.boardPosition?.includes(role)
    )
  );
};

export const findDirectorByRoleForCorporation = (
  data: DirectorReturnType[],
  role: BoardPositionEnum,
  corporationId: number
) => {
  return data?.find((director) =>
    director.corporationHasDirector?.some(
      (dir) =>
        dir.corporationId === corporationId &&
        dir.directorId === director.id &&
        dir.additionalDirectorInformation?.boardPosition?.includes(role)
    )
  );
};

export { BoardPositionEnum };
